import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Onderneming } from '../../models/Onderneming';
import { AanwerfSimulator } from '../../models/AanwerfSimulator';
import { Subject, throwError } from 'rxjs';
import { IFormBuilder, IFormGroup } from '@rxweb/types';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { OndernemingService } from '../../services/onderneming.service';
import { AanwerfSimulatorService } from '../../services/aanwerf-simulator.service';
import { DataService } from '../../services/data.service';
import { mergeMap, catchError, takeUntil } from 'rxjs/operators';
interface LoonBerekening {
  basisuurloon: number | 0,
  bruto: number | 0,
  basisBerekeningRSZ: number | 0,
  extraForfaitPerUur: number | 0,
  extraForfaitPerDag: number | 0,
  inhoudingRSZWerknemer: number | 0,
  werkbonus: number | 0,
  belastbaar: number | 0,
  inhoudingBv: number | 0,
  netto: number | 0,
  nettoPerUur: number | 0,
  totaalBijdragenWerkgever: number | 0,
  rszWerkgever: number | 0,
  fondsHoreca: number | 0,
  jaarlijkseVakantie: number | 0,
  totaleLoonkost: number | 0,
  loonkostPerUur: number | 0,
}
interface AanwerfForm {
  brutoUurloon: number | null,
  aantalUren: number | null
}

@Component({
  selector: 'app-aanwerfsimulator',
  templateUrl: './aanwerfsimulator.component.html',
  styleUrls: ['./aanwerfsimulator.component.scss']
})


export class AanwerfsimulatorComponent implements OnInit {

  // Boolean voor het vertonen van de uitkomst
  calculate = false;


  ondernemingNaam: string;
  onderneming: Onderneming;
  aanwerfsimulator: AanwerfSimulator;
  result: number = 0;

  componentDestoryed$: Subject<boolean> = new Subject();

  //form variabelen
  formBuilder: IFormBuilder;
  aanwerfFormGroup: IFormGroup<AanwerfForm>;

  //loonberekeningen
  student: LoonBerekening = {
    basisuurloon: 0,
    bruto: 0,
    basisBerekeningRSZ: 0,
    extraForfaitPerDag: 0,
    extraForfaitPerUur: 0,
    inhoudingRSZWerknemer: 0,
    werkbonus: 0,
    belastbaar: 0,
    inhoudingBv: 0,
    netto: 0,
    nettoPerUur: 0,
    totaalBijdragenWerkgever: 0,
    rszWerkgever: 0,
    fondsHoreca: 0,
    jaarlijkseVakantie: 0,
    totaleLoonkost: 0,
    loonkostPerUur: 0
  }
  flexiJob: LoonBerekening = {
    basisuurloon: 0,
    bruto: 0,
    basisBerekeningRSZ: 0,
    extraForfaitPerDag: 0,
    extraForfaitPerUur: 0,
    inhoudingRSZWerknemer: 0,
    werkbonus: 0,
    belastbaar: 0,
    inhoudingBv: 0,
    netto: 0,
    nettoPerUur: 0,
    totaalBijdragenWerkgever: 0,
    rszWerkgever: 0,
    fondsHoreca: 0,
    jaarlijkseVakantie: 0,
    totaleLoonkost: 0,
    loonkostPerUur: 0
  }
  extra: LoonBerekening = {
    basisuurloon: 0,
    bruto: 0,
    basisBerekeningRSZ: 0,
    extraForfaitPerDag: 0,
    extraForfaitPerUur: 0,
    inhoudingRSZWerknemer: 0,
    werkbonus: 0,
    belastbaar: 0,
    inhoudingBv: 0,
    netto: 0,
    nettoPerUur: 0,
    totaalBijdragenWerkgever: 0,
    rszWerkgever: 0,
    fondsHoreca: 0,
    jaarlijkseVakantie: 0,
    totaleLoonkost: 0,
    loonkostPerUur: 0
  }
  vastMedewerker: LoonBerekening = {
    basisuurloon: 0,
    bruto: 0,
    basisBerekeningRSZ: 0,
    extraForfaitPerDag: 0,
    extraForfaitPerUur: 0,
    inhoudingRSZWerknemer: 0,
    werkbonus: 0,
    belastbaar: 0,
    inhoudingBv: 0,
    netto: 0,
    nettoPerUur: 0,
    totaalBijdragenWerkgever: 0,
    rszWerkgever: 0,
    fondsHoreca: 0,
    jaarlijkseVakantie: 0,
    totaleLoonkost: 0,
    loonkostPerUur: 0
  }


  constructor(
    private route: ActivatedRoute,
    formBuilder: FormBuilder,
    private aanwerfsimulatorService: AanwerfSimulatorService,
    public dataService: DataService,
    private cd: ChangeDetectorRef,
  ) {
    this.formBuilder = formBuilder;
  }

  ngOnInit(): void {
    // Aanmaken van form
    this.aanwerfFormGroup = this.formBuilder.group<AanwerfForm>({

      brutoUurloon: this.formBuilder.control(null, [Validators.required, Validators.min(0)]),
      aantalUren: this.formBuilder.control(null, [Validators.required, Validators.min(0), Validators.max(11)]),
    });
    this.loadData();
  }
  loadData() {
    this.onderneming = this.dataService.getOnderneming();
    this.getaanwerfsimulator(this.onderneming.aanwerfSimulator);
  }



  //Wanneer de onderneming al in dataservice zit, laad de in.
  getaanwerfsimulator(id: string) {
    if (this.dataService.aanwerfSimulator === undefined) {
      this.aanwerfsimulatorService.getAanwerfSimulator(id).pipe(
        takeUntil(this.componentDestoryed$))
        .subscribe(e => {
          this.aanwerfsimulator = e;
          this.cd.markForCheck();
        });

    }
    else {
      this.aanwerfsimulator = this.dataService.aanwerfSimulator;
    }
  }

  onSubmit() {
    this.calculate = true;
    this.calculateLoon();
  }
  calculateLoon() {
    this.calculateStudent();
    this.calculateFlexi();
    this.calculateExtra();
    this.calculateMedewerker();
  }
    //calculations voor een jobstudent
  calculateStudent() {
    this.student.basisuurloon = this.aanwerfFormGroup.value.brutoUurloon;
    this.student.bruto = this.aanwerfFormGroup.value.brutoUurloon * this.aanwerfFormGroup.value.aantalUren;
    this.student.basisBerekeningRSZ = this.student.bruto;
    this.student.inhoudingRSZWerknemer = this.student.bruto * (this.aanwerfsimulator?.studentRSZWerknemer /100);
    this.student.werkbonus = 0.00;
    this.student.belastbaar = this.student.bruto - this.student.inhoudingRSZWerknemer;
    this.student.inhoudingBv = 0.00;
    this.student.netto = this.student.bruto - this.student.inhoudingRSZWerknemer;
    this.student.nettoPerUur = this.student.netto / this.aanwerfFormGroup.value.aantalUren;
    this.student.rszWerkgever = this.student.basisBerekeningRSZ * (this.aanwerfsimulator?.studentRSZWerkgever / 100);
    this.student.fondsHoreca = this.student.basisBerekeningRSZ * (this.aanwerfsimulator?.fondsHorecaPercentage / 100);
    this.student.jaarlijkseVakantie = 0.00;
    this.student.totaalBijdragenWerkgever = this.student.rszWerkgever + this.student.fondsHoreca + this.student.jaarlijkseVakantie;
    this.student.totaleLoonkost = this.student.bruto + this.student.totaalBijdragenWerkgever;
    this.student.loonkostPerUur = this.student.totaleLoonkost / this.aanwerfFormGroup.value.aantalUren;
  }
    //calculations voor een flexi
  calculateFlexi() {
    this.flexiJob.basisuurloon = this.aanwerfFormGroup.value.brutoUurloon;
    this.flexiJob.bruto = this.aanwerfFormGroup.value.brutoUurloon * this.aanwerfFormGroup.value.aantalUren;
    this.flexiJob.basisBerekeningRSZ = this.flexiJob.bruto;
    this.flexiJob.inhoudingRSZWerknemer = 0.00;
    this.flexiJob.werkbonus = 0.00;
    this.flexiJob.belastbaar = this.flexiJob.bruto;
    this.flexiJob.inhoudingBv = 0.00;
    this.flexiJob.netto = this.flexiJob.bruto;
    this.flexiJob.nettoPerUur = this.flexiJob.netto / this.aanwerfFormGroup.value.aantalUren;
    this.flexiJob.rszWerkgever = this.flexiJob.basisBerekeningRSZ * (this.aanwerfsimulator?.flexiRSZWerkgever/ 100);
    this.flexiJob.fondsHoreca = this.flexiJob.basisBerekeningRSZ * (this.aanwerfsimulator?.fondsHorecaPercentage / 100);
    this.flexiJob.jaarlijkseVakantie = 0.00;
    this.flexiJob.totaalBijdragenWerkgever = this.flexiJob.rszWerkgever + this.flexiJob.fondsHoreca + this.flexiJob.jaarlijkseVakantie;
    this.flexiJob.totaleLoonkost = this.flexiJob.bruto + this.flexiJob.totaalBijdragenWerkgever;
    this.flexiJob.loonkostPerUur = this.flexiJob.totaleLoonkost / this.aanwerfFormGroup.value.aantalUren;
  }
    //calculations voor een extra werkkracht
  calculateExtra() {
    this.extra.basisuurloon = this.aanwerfFormGroup.value.brutoUurloon;
    this.extra.bruto = this.aanwerfFormGroup.value.brutoUurloon * this.aanwerfFormGroup.value.aantalUren;
    this.extra.basisBerekeningRSZ =((this.aanwerfsimulator?.extraBasisBerekeningRSZ) * this.berekenMaxAantalUrenExtra()) *1.08;
    this.extra.inhoudingRSZWerknemer = this.extra.basisBerekeningRSZ * (13.07 / 100);
    this.extra.werkbonus = this.extra.basisBerekeningRSZ * (13.07 / 100);
    this.extra.belastbaar = this.extra.bruto;
    this.extra.inhoudingBv = this.extra.belastbaar * (this.aanwerfsimulator?.bedrijfsVoorheffing / 100);
    this.extra.netto = this.extra.belastbaar - this.extra.inhoudingBv;
    this.extra.nettoPerUur = this.extra.netto / this.aanwerfFormGroup.value.aantalUren;
    this.extra.rszWerkgever = this.extra.basisBerekeningRSZ * (this.aanwerfsimulator?.extraRSZWerkgever/ 100);
    this.extra.fondsHoreca = this.extra.basisBerekeningRSZ * (this.aanwerfsimulator?.fondsHorecaPercentage / 100);
    this.extra.jaarlijkseVakantie = (this.extra.bruto * 1.08) * (this.aanwerfsimulator?.jaarlijkseVakantie / 100);

    this.extra.totaalBijdragenWerkgever = this.extra.rszWerkgever + this.extra.fondsHoreca + this.extra.jaarlijkseVakantie;
    this.extra.totaleLoonkost = this.extra.bruto + this.extra.totaalBijdragenWerkgever;
    this.extra.loonkostPerUur = this.extra.totaleLoonkost / this.aanwerfFormGroup.value.aantalUren;
  }

  /**
   * @returns returns the max value of hours calculated for RSZ
   */
  berekenMaxAantalUrenExtra()
  {
    let maxUren = 6;
    if(this.aanwerfFormGroup.value.aantalUren < 6){maxUren = this.aanwerfFormGroup.value.aantalUren;}
    return maxUren;
  }

  // /**
  // * 
  // * @returns returns calculation of the total jaarlijkse vakantie
  // */
  // berekenJaarlijkseVakantieExtra()
  // {
  //   if(this.aanwerfFormGroup.value.aantalUren<8)
  //   {return (this.aanwerfsimulator?.extraForfaitPerUur * this.aanwerfFormGroup.value.aantalUren) * this.aanwerfsimulator?.jaarlijkseVakantie/100}
  //   else
  //   {return this.aanwerfsimulator?.extraForfaitPerDag * this.aanwerfsimulator?.jaarlijkseVakantie/100}
  // }

  //calculations medewerker
  calculateMedewerker() {
    this.vastMedewerker.basisuurloon = this.aanwerfFormGroup.value.brutoUurloon;
    this.vastMedewerker.bruto = this.aanwerfFormGroup.value.brutoUurloon * this.aanwerfFormGroup.value.aantalUren;
    this.vastMedewerker.basisBerekeningRSZ = this.vastMedewerker.bruto * 1.08;
    this.vastMedewerker.inhoudingRSZWerknemer = this.vastMedewerker.basisBerekeningRSZ * (13.07 / 100);
    this.vastMedewerker.werkbonus = this.berekeningWerkbonus();
    this.vastMedewerker.belastbaar = this.vastMedewerker.bruto - this.vastMedewerker.inhoudingRSZWerknemer + this.vastMedewerker.werkbonus;
    this.vastMedewerker.inhoudingBv = this.vastMedewerker.belastbaar * (this.aanwerfsimulator?.bedrijfsVoorheffing / 100);
    this.vastMedewerker.netto = this.vastMedewerker.belastbaar - this.vastMedewerker.inhoudingBv;
    this.vastMedewerker.nettoPerUur = this.vastMedewerker.netto / this.aanwerfFormGroup.value.aantalUren;
    this.vastMedewerker.rszWerkgever = this.vastMedewerker.basisBerekeningRSZ * (this.aanwerfsimulator?.werknemerRSZWerkgever/ 100);
    this.vastMedewerker.fondsHoreca = this.vastMedewerker.basisBerekeningRSZ * (this.aanwerfsimulator?.fondsHorecaPercentage / 100);
    this.vastMedewerker.jaarlijkseVakantie = this.vastMedewerker.basisBerekeningRSZ * (this.aanwerfsimulator?.jaarlijkseVakantie / 100);
    this.vastMedewerker.totaalBijdragenWerkgever = this.vastMedewerker.rszWerkgever + this.vastMedewerker.fondsHoreca + this.vastMedewerker.jaarlijkseVakantie;
    this.vastMedewerker.totaleLoonkost = this.vastMedewerker.bruto + this.vastMedewerker.totaalBijdragenWerkgever;
    this.vastMedewerker.loonkostPerUur = this.vastMedewerker.totaleLoonkost / this.aanwerfFormGroup.value.aantalUren;
  }

  // berekenen van de werkbonus
  berekeningWerkbonus(): number
  {
    //referentiemaandloon
    let s = (this.aanwerfFormGroup.value.aantalUren * 7.6 / this.aanwerfFormGroup.value.aantalUren) * this.aanwerfsimulator?.werkbonusdagen * this.vastMedewerker.basisuurloon;

    let finaalMaandbedrag = s * 1.08
    let werkbonus = 0;

    let resultLuik1 = 0;
    let resultLuik2 = 0;

    //Berekening Luik 1 - Lage Lonen
        if(finaalMaandbedrag <= this.aanwerfsimulator?.werkbonusOndergrensLuikA)
    {
      resultLuik1 = this.aanwerfsimulator?.werkbonusMinimumLuikA;
    }
    else if (finaalMaandbedrag > this.aanwerfsimulator?.werkbonusOndergrensLuikA && finaalMaandbedrag <= this.aanwerfsimulator?.werkbonusBovengrensLuikA)
    {
      resultLuik1 = (this.aanwerfsimulator?.werkbonusMinimumLuikA - ((this.aanwerfsimulator?.werkbonusFactorLuikA)* (finaalMaandbedrag - this.aanwerfsimulator?.werkbonusOndergrensLuikA)));
    }


    //Berekening Luik 2 
    if (finaalMaandbedrag <= this.aanwerfsimulator?.werkbonusOndergrensLuikB) {
      resultLuik2 = this.aanwerfsimulator?.werkbonusMinimumLuikB
    }
    else if (finaalMaandbedrag > this.aanwerfsimulator?.werkbonusOndergrensLuikB && finaalMaandbedrag <= this.aanwerfsimulator?.werkbonusBovengrensLuikB) {
      resultLuik2 = (this.aanwerfsimulator?.werkbonusMinimumLuikB  - ((this.aanwerfsimulator?.werkbonusFactorLuikB) * (finaalMaandbedrag - this.aanwerfsimulator?.werkbonusOndergrensLuikB)));
    }

    //Berekening werkbonus
    let totaal = resultLuik1 + resultLuik2;
    werkbonus = totaal / this.aanwerfsimulator?.werkbonusdagen / 7.6 *  this.aanwerfFormGroup.value.aantalUren;


    return werkbonus;
    

  }

  // Auto unsub
  ngOnDestroy() {
    this.componentDestoryed$.next(true);
    // Now let's also unsubscribe from the subject itself:
    this.componentDestoryed$.unsubscribe();
  }
}
